<style>
  .BMap_cpyCtrl[unselectable],
  .anchorBL {
    display: none;
  }

  .fullParent {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .fullParent .ec-extension-bmap {
    background-color: transparent !important;
  }

  .hiden-map .fullParent img {
    visibility: hidden;
  }

  .inmap-scale-group>a {
    background: #120422;
    color: #ffffff;
    user-select: none;
  }

  .inmap-scale-group>a[disabled] {
    color: rgba(187, 190, 196, 0.6);
    background-color: #080808;
    border-color: #dddee1;
  }
</style>
<template>
  <div class="fullParent " :class="[showMap?'':'hiden-map']">
    <div class="fullParent" ref="map"></div>
    <div class="inmap-scale-group" v-if="config.zoom.show">
      <a @click="onScaleUp" :disabled="scaleUpDisabled">+</a>
      <a @click="onScaleDown" :disabled="scaleDownDisabled">-</a>
    </div>
  </div>
</template>
<script>
  import echarts from "echarts";
  import './extension-src/bmap/bmap';
  import abstractEchartMap from "./abstractEchartMap.js";
  import {
    Blueness
  } from "./map-config.js";
  import {
    merge
  } from './../../../tool/util';

  export default {
    name: "echartBmap",
    props: {
      isLabelText: { //地图底图文字显示控制
        type: Boolean,
        default: true
      }
    },
    mixins: [abstractEchartMap],
    data() {
      const cache = {
        echart: null
      }
      return {
        styleStr: [],
        showMap: true,
        scaleDownDisabled: true,
        scaleUpDisabled: true,
        coordinateSystem: "bmap",
        getCache() {
          return cache;
        },
        config: {
          center: ["114.215408", "22.654411"],
          zoom: {
            value: 11,
            show: true,
            max: 19,
            min: 3
          },
          roam: true,
          skin: undefined

        }
      };
    },
    watch: {
      isLabelText(newVal, oldVal) {
        if (oldVal != newVal) {
          this.setMapLabels();
        }
      }
    },
    computed: {

    },
    methods: {
      createMap() {
        const cache = this.getCache();
        if (cache.echart) {
          cache.echart.dispose();
        }

        let myChart = echarts.init(this.$refs.map);
        cache.echart = myChart;
        this.getCacheData().echart = myChart;
        let option = this.config;
        myChart.setOption({
          bmap: {
            center: option.center,
            zoom: option.zoom.value,
            // roam: false
          },
          tooltip: {
            trigger: "item"
          }
        }, {
          notMerge: false,
          lazyUpdate: false
        });
        this.bindPrintInfo();
        this.setStyle(this.config.skin);
      },
      processStyleJson(json) {
        json = JSON.parse(JSON.stringify(json))

        const visibilty = this.isLabelText ? 'on' : 'off';
        let featureType = {
          'highway': false,
          'label': false
        }
        for (let index = 0; index < json.length; index++) {
          const element = json[index];
          if (element['elementType'] === 'labels') {
            if (element['stylers']) {
              element['stylers'].visibility = visibilty;
            } else {
              element['stylers'] = {
                'visibility': visibilty
              };
            }
            featureType[element['featureType']] = true;
          }
        }
        for (const key in featureType) {
          if (featureType[key] == false) {
            json.push({
              'featureType': key,
              'elementType': 'labels',
              'stylers': {
                'visibility': visibilty
              }
            });
          }
        }
        return json;
      },
      setStyle(skin) {
        let bmap = this.getMap();
        if (!bmap) return;

        this.config.skin = skin;

        let styleJson = null;

        if (this.config.skin == undefined) {
          styleJson = Blueness;
        } else if (Array.isArray(this.config.skin)) {
          if (this.config.skin.length === 0) {
            styleJson = Blueness;
          } else {
            styleJson = this.config.skin;
          }

        }

        styleJson = this.processStyleJson(styleJson);
        if (styleJson != null && JSON.stringify(this.styleStr) != JSON.stringify(styleJson)) {
          this.styleStr = styleJson;

          // if (styleJson == Blueness) {

          bmap.setMapStyle({
            styleJson: styleJson
          });


          // } else {

          //   bmap.setMapStyleV2({
          //     styleJson: styleJson
          //   });
          // }

        }

      },
      setMapLabels() {
        this.setStyle(this.styleStr);
      },
      /**
       * 返回baiduMap实例
       */
      getMap() {
        const myEchart = this.getCacheData().echart;
        if (myEchart == null) return;

        const model = myEchart.getModel();
        if (model == null) return;

        return model.getComponent("bmap")
          .getBMap();

      },
      getEcharts() {
        return this.getCacheData().echart;
      },
      show() {
        this.showMap = true;
      },
      hide() {
        this.showMap = false;
      },
      bindPrintInfo() {
        let bmap = this.getMap();

        const print = () => {
          let center = bmap.getCenter();
          let zoom = bmap.getZoom();

          this.config.zoom.value = zoom;

          console.log(`Map: center:${JSON.stringify(center)} zoom:${zoom}`);
        }

        bmap.removeEventListener("moveend", print);
        bmap.removeEventListener("zoomend", print);
        bmap.addEventListener("moveend", print);
        bmap.addEventListener("zoomend", print);
        // bmap.disableDoubleClickZoom(); //禁用双击放大

      },
      
      setCenter(lng, lat,record) {
        const bmap = this.getMap();
        const mapCenter = bmap.getCenter();
        if (mapCenter.lng != lng || mapCenter.lat != lat||record) {
          this.config.center = [lng, lat];
          bmap.setCenter(new BMap.Point(lng, lat));
        }

      },
      centerAndZoom(lng, lat, zoom) {
        const bmap = this.getMap();
        const mapCenter = bmap.getCenter();
        const mapZoom = bmap.getZoom();

        var isUpdateCenter = mapCenter.lng != lng || mapCenter.lat != lat;
        var isUpdateZoom = mapZoom != zoom;

        if (isUpdateCenter && isUpdateZoom) {

          const pt = new BMap.Point(lng, lat);
          this.config.center = [lng, lat];
          this.config.zoom.value = zoom;
          bmap.centerAndZoom(pt, zoom);

        } else if (isUpdateCenter) {

          this.config.center = [lng, lat];
          const pt = new BMap.Point(lng, lat);
          bmap.setCenter(pt);

        } else if (isUpdateZoom) {
          this.config.zoom.value = zoom;
          bmap.setZoom(zoom);
        }
        this.setButtonState();
      },
       
      setZoom(val) {
        this.setZoomConfig({
          value: val
        });
      },
      setZoomConfig(zoomConfig) {
        const map = this.getMap();
        this.config.zoom = merge(this.config.zoom, zoomConfig);
        if (map == null) return;
        if (map.getZoom() != this.config.zoom.value) {
          map.setZoom(this.config.zoom.value);
        }
        this.setButtonState();
      },
      beforeDestroy() {
        this.getEcharts().dispose();
      },
      setButtonState() {
        let map = this.getMap();
        let zoomConfig = this.config.zoom;

        map && map.setMinZoom(zoomConfig.min);
        map && map.setMaxZoom(zoomConfig.max);

        let zoom = map.getZoom();
        if (zoom >= zoomConfig.max) {
          this.scaleUpDisabled = true;
        } else {
          this.scaleUpDisabled = false;
        }
        if (zoom <= zoomConfig.min) {
          this.scaleDownDisabled = true;
        } else {
          this.scaleDownDisabled = false;
        }

      },
      onScaleUp() {
        let map = this.getMap();
        if (!this.scaleUpDisabled) {
          map.zoomIn();
        }
        this.setButtonState();
      },
      onScaleDown() {
        let map = this.getMap();
        if (!this.scaleDownDisabled) {
          map.zoomOut();
        }
        this.setButtonState();
      },
      /**
       * 添加图层
       */
      addInMapOverlay(overlay) {
        this.getMap().addOverlay(overlay);
      },
      /**
       * 删除图层
       */
      removeInMapOverlay(overlay) {
        overlay.dispose();
      },
      create() {
        this.createMap();
        this.setButtonState();
        this.$emit('map-load');
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.create();
      });

    }
  };
</script>